<div @fadeInAnimation>
  <div class="florder-page">
    <div class="florder-page-title">
      <span class="title">
        {{ 'ADMIN.GENERAL.CLIENT_USERS' | translate }}
      </span>
      <div class="buttons">
        <eps-button
          label="ADMIN.SHARED.CREATE"
          buttonIcon="plus-square"
          (buttonClick)="createNewClientUser()"
          *ngIf="userContext.adminRoles.createClientUser"
          ></eps-button>
      </div>
    </div>
  </div>
  <div class="florder-page-search">
    <admin-client-user-filter
      (filterUsers)="filterUsers($event)"
      [isLoading]="users.loading"
      [salesOrganisations]="adminDefinitions.salesOrganisation"
      [soldTos]="soldTos"
      (salesOrganisationSelected)="salesOrganisationSelected($event)"
    > </admin-client-user-filter>
  </div>
  <div class="florder-page-list" id="users-list">
    <admin-client-user-list
      [isLoading]="users.loading"
      [totalItems]="users.totalItems"
      [pageNr]="users.pageNr"
      [pageSize]="users.pageSize"
      [sortField]="sortField"
      [sortAscending]="sortAscending"
      [users]="users.items"
      [isDownloading]="usersSandbox.clientUsersDownloading$ | async"
      (pageChange)="onPageChange($event)"
      (openUser)="openClientUser($event)"
      (sortChange)="sortChange($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)"
      (downloadList)="downloadList()"
    >
    </admin-client-user-list>
  </div>
</div>
